import React from 'react';
import {Amplify, Auth} from 'aws-amplify';
import awsconfig from './aws-exports';
import {CognitoHostedUIIdentityProvider} from "@aws-amplify/auth";
import {Dashboard} from "./components/Dashboard";
import {BrowserRouter, Navigate, Routes, Route} from "react-router-dom";
import {JourneyMapEditor} from "./components/JourneyMapEditor";
import {useUserInfo} from "./hooks/useUserInfo";
import {BeforeLogin} from "./components/BeforeLogin";
import {is_dev} from "./utils/debug";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

if (!is_dev()) {
    Sentry.init({
        dsn: "https://8c21d6fa9676488d8c395d4a6067488a@o4504298714169344.ingest.sentry.io/4504298715676672",
        integrations: [new BrowserTracing()],
        tracesSampleRate: 1.0,
    });
}


const env = window.location.hostname.match(/^[^.]+/)?.[0] || '';
const env_index = ['app', 'prod', 'stg', 'localhost'].indexOf(env);
if (awsconfig.oauth.redirectSignIn.match(/,/)) {
    awsconfig.oauth.redirectSignIn = awsconfig.oauth.redirectSignIn.split(",")[env_index];
    awsconfig.oauth.redirectSignOut = awsconfig.oauth.redirectSignOut.split(",")[env_index];
}
if (env === 'localhost') {
    if (is_dev()) {
        if (!awsconfig.aws_appsync_graphqlEndpoint.match(/:2000[24]/)) {
            alert("please check aws_appsync_graphqlEndpoint");
        }
    }
} else if (env === 'app') {
    awsconfig.oauth.domain = 'auth.jourcy.com';
}

Amplify.configure(awsconfig);


const App = () => {
    const {isLogin} = useUserInfo();

    return isLogin ? (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path='/' element={<Dashboard/>}/>
                    <Route path='/m/:mapId' element={<JourneyMapEditor/>}/>
                    <Route path="*" element={<Navigate to="/" replace/>}/>
                </Routes>
            </BrowserRouter>
        </div>
    ) : (
        <BeforeLogin onLoginClick={() => Auth.federatedSignIn({provider: CognitoHostedUIIdentityProvider.Google})}/>
    );
}

export default App;
